(function() {
    'use strict';

    angular.module('caffeprint')
        .directive('cpInputTimepicker', cpInputTimepicker);

    cpInputTimepicker.$inject = ['dateFormatConst', 'momentSrvc'];

    function cpInputTimepicker(dateFormatConst, momentSrvc) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/caffeprint/directives/input-timepicker/input-timepicker.html',
            scope: {
                title: '@',
                object: '=',
                prop: '@',
                isRequired: '=?',
                isDisabled: '=?',
                onChange: '&?'
            },
            link: function(scope, element, attrs, controller) {
                scope.format = dateFormatConst.timePicker;
                scope.isOpened = false;
                scope.openPopup = openPopup;

                scope.change = change;
                scope.proxyDate = null;

                scope.dateOptions = {};

                scope.$watch('object', function(newValue, oldValue) {
                    if (scope.object && scope.object[scope.prop]) {
                        scope.proxyDate = momentSrvc.strToTime(scope.object[scope.prop]);
                    }
                });

                function change() {
                    scope.object[scope.prop] = scope.proxyDate ? momentSrvc.timeToStr(scope.proxyDate) : null;

                    if (scope.onChange) {
                        scope.onChange();
                    }
                }

                function openPopup() {
                    scope.isOpened = true;
                }
            }
        };
    }
})();
